module.exports = __webpack_public_path__ + "static/media/loi-luu-200x200.9a197e7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/page/company/advisors/images/loi-luu-200x200.jpg
// module id = 1766
// module chunks = 146